module.exports = __webpack_public_path__ + "static/media/bg.0f596cbe.png";